module.exports = __webpack_public_path__ + "img/quickresume3.941a1bf5.png";